import {Button} from '@nlabs/gothamjs';

import ufatProjectsOfficeHero from '../../assets/ufat-projects-office-hero.png';
import {Hero} from '../../components/Hero';
import {Page} from '../../components/Page';
import {ProjectTile} from '../../components/ProjectTile';
import {RotatingHeroTitle} from '../../components/RotatingHeroTitle';
import {Section} from '../../components/Section';
import {PROJECTS_HERO_TITLES} from '../../data/heroTitles';
import {projectGroups} from '../../data/projects';
import {navigate} from '../../lib/navigation';
import {buttonDarkPrimary, buttonDarkSecondary, projectGrid} from '../../lib/styles';
import {Route} from '../../types/routes';

export const Projects = ({route}: {route: Route}) => (
  <Page route={route}>
    <Hero
      actions={(
        <>
          <Button className={buttonDarkPrimary} onClick={() => navigate('/publishing')}>Publishing</Button>
          <Button className={buttonDarkSecondary} onClick={() => navigate('/coding')}>Coding</Button>
        </>
      )}
      backgroundImage={ufatProjectsOfficeHero}
      copyTone="dark"
      imageLabel="Projects placeholder image"
      kicker="Projects"
      subtitle="UFAT transforms ideas into books, applications, digital platforms, and creative experiences for the modern era."
      title={<RotatingHeroTitle items={PROJECTS_HERO_TITLES} />}
      tone="cyan"
    />
    {projectGroups
      .map((group, index) => (
      <Section className={`nx-section-projects ${index % 2 === 1 ? 'nx-section-projects-alt' : ''}`} key={group.id} title={group.title}>
        <div className={projectGrid}>
          {group
            .items
            .filter((project) => project.visible)
            .map((project) => <ProjectTile key={project.slug} {...project} />)}
        </div>
      </Section>
    ))}
  </Page>
);
